import React from "react";
import ToggleIcon, { TToggleIconProps } from "./ToggleIcon";
import { Link } from "react-router-dom";

const ToggleIconLink = ({
  to,
  ...props
}: { to: string } & TToggleIconProps) => {
  return (
    <Link to={to} style={{ color: "inherit", display: "contents" }}>
      <ToggleIcon {...props} />
    </Link>
  );
};

export default ToggleIconLink;
